<app-journey-list-template-checkbox
        *ngIf="task.task" class="blue"
        [task]="task"></app-journey-list-template-checkbox>

<div class="text">
    <div *ngIf="!task.task" class="title my-color-blue" [innerHTML]="(for_manager ? task.title_for_manager ?? task.title : task.title) | safeHtml"></div>
    <div class="text-legend" *ngIf="(!task.url || task.url === 'default')">
        <span><strong class="my-color-blue">1</strong> - {{'__JOURNEY_FEEDBACK_LEGEND1__' | translate}}</span>
        <span><strong class="my-color-blue">2</strong> - {{'__JOURNEY_FEEDBACK_LEGEND2__' | translate}}</span>
        <span><strong class="my-color-blue">3</strong> - {{'__JOURNEY_FEEDBACK_LEGEND3__' | translate}}</span>
        <span><strong class="my-color-blue">4</strong> - {{'__JOURNEY_FEEDBACK_LEGEND4__' | translate}}</span>
        <span><strong class="my-color-blue">5</strong> - {{'__JOURNEY_FEEDBACK_LEGEND5__' | translate}}</span>
    </div>
</div>

<div class="feedback-list">
    <div class="item" *ngFor="let question of task.details.custom_feedback.answers; let i = index;">
        <div class="number my-color-blue">{{i + 1}}.</div>
        <div class="content">
            <div class="text">
                {{question.question.title}}
            </div>
            <app-radio-group (valueChange)="onChange($event)" [items]="radioGroup" [highlight]="highlight" [(value)]="question.value" [disabled]="disabled" class="swiper-no-swiping"></app-radio-group>
        </div>
    </div>
</div>
